export const Options = {
    Salutation: [
         { text:"männlich",value:"männlich"},
         { text:"weiblich",value:"weiblich"},
         { text:"divers",value:"divers"},
    ],
    BecomingAwareThrough: [
        { text:"Agentur für Arbeit",value:"Agentur für Arbeit"},
        { text:"Anzeige (Zeitung / Wochenblatt etc.)",value:"Anzeige (Zeitung / Wochenblatt etc.)"},
        { text:"Ausbildung.de",value:"Ausbildung.de"},
        { text:"Ausbildungsatlas",value:"Ausbildungsatlas"},
        { text:"Azubi.de",value:"Azubi.de"},
        { text:"azubica",value:"azubica"},
        { text:"AzubiWelt",value:"AzubiWelt"},
        { text:"Azubiyo",value:"Azubiyo"},
        { text:"Bekannte/Verwandte/Empfehlung/Kontakte",value:"Bekannte/Verwandte/Empfehlung/Kontakte"},
        { text:"Bildungsmesse / Studientag / Veranstaltung",value:"Bildungsmesse / Studientag / Veranstaltung"},
        { text:"ebay-kleinanzeigen",value:"ebay-kleinanzeigen"},
        { text:"E-Zubis",value:"E-Zubis"},
        { text:"Facebook",value:"Facebook"},
        { text:"Firmenwagen",value:"Firmenwagen"},
        { text:"glassdoor",value:"glassdoor"},
        { text:"Google",value:"Google"},
        { text:"Handwerkskammer (Lehrstellenbörse)",value:"Handwerkskammer (Lehrstellenbörse)"},
        { text:"HEISE Jobs",value:"HEISE Jobs"},
        { text:"Heldele Stiftung",value:"Heldele Stiftung"},
        { text:"HeyJobs",value:"HeyJobs"},
        { text:"hokify!",value:"hokify!"},
        { text:"Homepage / Karriereseite",value:"Homepage / Karriereseite"},
        { text:"IHK-Lehrstellen- & Praktikumsbörse",value:"IHK-Lehrstellen- & Praktikumsbörse"},
        { text:"Indeed",value:"Indeed"},
        { text:"Instagram",value:"Instagram"},
        { text:"Internet",value:"Internet"},
        { text:"Jobblitz",value:"Jobblitz"},
        { text:"Jobbörse.de",value:"Jobbörse.de"},
        { text:"Jobware",value:"Jobware"},
        { text:"Kimeta",value:"Kimeta"},
        { text:"Kinospot / Kinowerbung",value:"Kinospot / Kinowerbung"},
        { text:"kleinanzeigen",value:"kleinanzeigen"},
        { text:"LinkedIN",value:"LinkedIN"},
        { text:"Localjob.de",value:"Localjob.de"},
        { text:"MeineStadt.de",value:"MeineStadt.de"},
        { text:"Mitarbeiter Empfehlung",value:"Mitarbeiter Empfehlung"},
        { text:"Monster",value:"Monster"},
        { text:"Nacht der Ausbildung",value:"Nacht der Ausbildung"},
        { text:"Plakate / LED-Wand",value:"Plakate / LED-Wand"},
        { text:"POWER US Plattform",value:"POWER US Plattform"},
        { text:"Praktikum / Ferienjob",value:"Praktikum / Ferienjob"},
        { text:"Schule / Bildungspartnerschaft / Hochschule",value:"Schule / Bildungspartnerschaft / Hochschule"},
        { text:"Sonstiges…",value:"Sonstiges…"},
        { text:"Stellenanzeigen.de",value:"Stellenanzeigen.de"},
        { text:"StepStone.de",value:"StepStone.de"},
        { text:"Studyflix",value:"Studyflix"},
        { text:"Telefonischer Kontakt",value:"Telefonischer Kontakt"},
        { text:"TikTok",value:"TikTok"},
        { text:"Werbeanzeige/Plakat/digitale Werbung",value:"Werbeanzeige/Plakat/digitale Werbung"},
        { text:"XING",value:"XING"},
        { text:"YourFirm",value:"YourFirm"},
        { text:"YouTube" ,value:"YouTube"},
    ]
}
